import styles from "./index.module.less";
import { Flex } from "antd";
import P4Card from "./components/P4Card";
import data from "./data";
import P1Content from "@/components/P1Content";
import TitleWithBorder from "@/components/TitleWithBorder";
import { isMobile } from "@/utils";
import MobileAboutUs from "./mobile/mobile";
const AboutUs = () => {
  const { p1, p2, p3, p4 } = data;
  return (
    <div className={styles.aboutPage}>
      <div className={styles.p1}>
        <P1Content title={p1.title} subtitle={p1.subtitle} showBtn={false} />
      </div>
      <div className={styles.p2}>
        <div className={styles.p2_inner}>
          <TitleWithBorder text={p2.title} />
          <div className={styles.p2_subtitle}>{p2.subTitle}</div>
          <Flex align="center" gap={".35rem"} className={styles.p2_intro}>
            <img className={styles.p2_img1} src={p2.bannerImg} />
            <Flex vertical gap={".2rem"}>
              <Flex gap={".23rem"} align="center">
                <img className={styles.p2_img2} src={p2.quoteImg} />
                {p2.description1}
              </Flex>
              <div>{p2.description2}</div>
            </Flex>
          </Flex>
        </div>
      </div>
      <div className={styles.p3}>
        <div className={styles.p3_inner}>
          <TitleWithBorder text={p3.title} />
          <div className={styles.p3_honor}>{p3.subTitle}</div>
          <div className={styles.p3_list}>
            <Flex gap={24}>
              {p3.list.map((row, rowIndex) => (
                <Flex
                  vertical
                  gap={24}
                  key={rowIndex}
                  className={
                    rowIndex % 2 === 0 ? styles.p4_row_even : styles.p4_row_odd
                  }
                  style={{ flex: 1 }}
                >
                  {row.map((item, itemIndex) => (
                    <P4Card key={itemIndex} {...item} />
                  ))}
                </Flex>
              ))}
            </Flex>
          </div>
        </div>
      </div>

      <div className={styles.p4}>
        <div className={styles.p4_inner}>
          <TitleWithBorder text={p4.title} />
          <div className={styles.p4_subtitle}>{p4.subTitle}</div>
          <img src={p4.img1} />
          <img src={p4.img2} />
        </div>
      </div>
    </div>
  );
};

export default isMobile() ? MobileAboutUs : AboutUs;
